/** @prettier */
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "./FinishTestView.css";
import { TestRunnerDispatch } from "./testRunnerState";

const FINISH_TEST_BUTTON_TEXT = "Finish Test";

type FinishTestViewProps = {
    questionsAnswered: number;
    totalQuestionCount: number;
    dispatch: TestRunnerDispatch;
};
const FinishTestView = ({
    questionsAnswered,
    totalQuestionCount,
    dispatch,
}: FinishTestViewProps) => {
    const allQuestionsAnswered = questionsAnswered === totalQuestionCount;
    const finishTest = () => dispatch({ event: "finishTest" });
    return (
        <div className="tr-main-content tr-wrapup">
            <p className="tr-content-heading">Test Review</p>
            <div>
                Questions answered: {questionsAnswered}/{totalQuestionCount}
            </div>
            <div className="tr-wrapup-footer">
                {!allQuestionsAnswered ? (
                    <ConfirmationFooter finishTest={finishTest} />
                ) : (
                    <button className="btn btn-success" onClick={finishTest}>
                        {FINISH_TEST_BUTTON_TEXT}
                    </button>
                )}
            </div>
        </div>
    );
};

type ConfirmationFooterProps = {
    finishTest: () => void;
};
const ConfirmationFooter = ({ finishTest }: ConfirmationFooterProps) => {
    const [hasConfirmed, setConfirmed] = useState(false);
    return (
        <>
            <p className="tr-confirm-unanswered">
                <input
                    type="checkbox"
                    checked={hasConfirmed}
                    onChange={(e) => setConfirmed(e.currentTarget.checked)}
                />
                Finish test with unanswered questions
            </p>
            <Button
                disabled={!hasConfirmed}
                bsStyle="danger"
                onClick={finishTest}
            >
                {FINISH_TEST_BUTTON_TEXT}
            </Button>
        </>
    );
};

export default FinishTestView;
